<template>
    <div class="auth-table">
        <div class="auth-table-title-container">
            <div class="auth-table-title">版块</div>
            <div class="auth-table-title-choose">
                <Checkbox
                    class="auth-table-checkbox"
                    v-model="menuData[0].selected"
                    :indeterminate="menuData[0].isInterminate"
                    @on-change="checkItem(1)"
                    >全选</Checkbox
                >
            </div>
        </div>
        <div class="auth-table-content">
            <div class="auth-table-content-menu">
                <div
                    v-for="menuItem in treeData"
                    :key="menuItem.id"
                    @click="toMenu(menuItem)"
                >
                    <div
                        :class="`auth-table-title ${
                            menuItem.isActive ? 'menu-active' : ''
                        }`"
                    >
                        {{ menuItem.title }}
                    </div>
                </div>
            </div>
            <div
                class="auth-table-content-container"
                ref="authTableContent"
                @scroll="throttle(scrollContent)"
            >
                <div class="auth-table-menu-container" v-for="contentItem in treeData" :key="contentItem.key">
                    <div :id="`menu-${contentItem.id}`">
                        <div class="auth-table-module-title">
                            {{ contentItem.title }}
                        </div>
                        <div
                            v-for="childContentItem in contentItem.children"
                            :key="childContentItem.id"
                        >
                            <div class="auth-table-content-title">
                                <div class="auth-table-title">
                                    {{ childContentItem.title }}
                                </div>
                                <div>
                                    <Checkbox
                                        :indeterminate="
                                            childContentItem.isInterminate
                                        "
                                        v-model="childContentItem.selected"
                                        class="auth-table-checkbox"
                                        @on-change="
                                            checkItem(childContentItem.id)
                                        "
                                        >全选</Checkbox
                                    >
                                </div>
                            </div>
                            <div class="auth-table-content-table">
                                <div
                                    class="second-table"
                                    v-for="secondItem in childContentItem.children"
                                    :key="secondItem.id"
                                >
                                    <div class="second-table-title">
                                        <Checkbox
                                            :indeterminate="
                                                secondItem.isInterminate
                                            "
                                            v-model="secondItem.selected"
                                            class="auth-second-table-checkbox"
                                            @on-change="
                                                checkItem(secondItem.id)
                                            "
                                            >{{ secondItem.title }}</Checkbox
                                        >
                                    </div>
                                    <div class="second-table-content">
                                        <Checkbox
                                            style="min-width: 240px"
                                            v-for="thirdItem in secondItem.children"
                                            :indeterminate="
                                                thirdItem.isInterminate
                                            "
                                            v-model="thirdItem.selected"
                                            :key="thirdItem.id"
                                            class="auth-second-table-checkbox"
                                            @on-change="checkItem(thirdItem.id)"
                                            >{{ thirdItem.title }}</Checkbox
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["menuData"],
    watch: {
        menuData: {
            immediate: true,
            handler(menuData) {
                if (!menuData.length) return;
                this.treeData = menuData[0].children;
                this.treeData[0].isActive = true;
                this.handleTreeData(menuData[0]);
            },
        },
    },
    data() {
        return {
            treeData: [],
            // 维护的数据索引
            dataMap: new Map(),
            // 维护的选中数据的id集合
            selectedSet: new Set(),
            canRun: true,
        };
    },
    methods: {
        /**
         * 递归数据，生成Map和Set
         */
        async handleTreeData(item) {
            this.dataMap.set(item.id, item);
            if (item.selected) {
                this.selectedSet.add(item.id);
            }
            if (!item.children || !item.children.length) {
                return;
            }
            await item.children.map((item) => {
                this.handleTreeData(item);
            });
            // 遍历children时，子级的interminate还未计算完成，所以需要在遍历子级之后进行计算
            let childLength = item.children.length;
            let childSelected = item.children.filter((item) => {
                return item.selected === true;
            }).length;
            let interminateLength = item.children.filter((item) => {
                return item.isInterminate === true;
            }).length;
            if (childLength === childSelected || !childSelected) {
                if (interminateLength > 0) {
                    item.isInterminate = true;
                } else {
                    item.isInterminate = false;
                }
            } else {
                item.isInterminate = true;
            }
            
            // 全部执行完后，重新计算root元素的展示问题
            let nodeItem = this.dataMap.get(1);
            let rootInterminateLength = nodeItem.children.filter((item) => {
                return item.isInterminate === true;
            }).length;
            if (rootInterminateLength > 0) {
                nodeItem.isInterminate = true;
            } else {
                nodeItem.isInterminate = false;
            }
            this.$forceUpdate();
        },
        checkItem(id) {
            let item = this.dataMap.get(id);
            let that = this;
            let flag = item.selected;
            // 向下递归遍历所有的子元素同步状态
            function toNext(item) {
                if (flag) {
                    that.selectedSet.add(item.id);
                } else {
                    that.selectedSet.delete(item.id);
                }
                item.selected = flag;
                item.isInterminate = false;
                if (!item.children) return;
                item.children.map((item) => {
                    toNext(item, flag);
                });
            }
            toNext(item);
            // 向上递归遍历所有的父元素同步状态
            function toPrev(item) {
                let parentNode = that.dataMap.get(item.parentId);
                if (!parentNode) return;
                let brotherNodeArr = parentNode.children;
                let selectedLength = brotherNodeArr.filter((item) => {
                    return item.selected === true;
                }).length;
                let interminateLength = brotherNodeArr.filter((item) => {
                    return item.isInterminate === true;
                }).length;
                let brotherLength = brotherNodeArr.length;
                if (parentNode.id === 1) {
                    if (selectedLength === brotherLength) {
                        if (interminateLength > 0) {
                            parentNode.isInterminate = true;
                        } else {
                            parentNode.isInterminate = false;
                        }
                        parentNode.selected = true;
                        that.selectedSet.add(parentNode.id);
                    } else if (!selectedLength) {
                        parentNode.selected = false;
                        parentNode.isInterminate = false;
                        that.selectedSet.delete(parentNode.id);
                    } else {
                        parentNode.selected = false;
                        parentNode.isInterminate = true;
                        that.selectedSet.add(parentNode.id);
                    }
                } else {
                    if (selectedLength === brotherLength) {
                        if (interminateLength > 0) {
                            parentNode.isInterminate = true;
                        } else {
                            parentNode.isInterminate = false;
                        }
                        that.selectedSet.add(parentNode.id);
                    } else if (!selectedLength) {
                        parentNode.selected = false;
                        parentNode.isInterminate = false;
                        that.selectedSet.delete(parentNode.id);
                    } else {
                        parentNode.selected = true;
                        parentNode.isInterminate = true;
                        that.selectedSet.add(parentNode.id);
                    }
                }
                toPrev(parentNode);
            }
            toPrev(item);
            console.log(that.selectedSet);
        },
        // 函数节流
        throttle(fn, interval = 300) {
            if (!this.canRun) return;
            this.canRun = false;
            fn();
            setTimeout(() => {
                this.canRun = true;
                fn();
            }, interval);
        },
        // 判断当前滑动到哪个菜单
        scrollContent() {
            let nowItem = {};
            let parentOffsetTop = this.$refs.authTableContent.offsetTop;
            for (let i = 0; i < this.treeData.length; i++) {
                let itemOffsetTop =
                    document.querySelector(`#menu-${this.treeData[i].id}`)
                        .offsetTop - parentOffsetTop;
                let nowScrollTop = this.$refs.authTableContent.scrollTop + 100;
                if (itemOffsetTop >= nowScrollTop) {
                    if (i - 1 < 0) {
                        nowItem = this.treeData[i];
                    } else {
                        nowItem = this.treeData[i - 1];
                    }
                    break;
                }
            }
            // console.log(nowItem.title);
            this.toMenu(nowItem, true);
        },
        // 跳转到菜单
        toMenu(item, onlyShow = false) {
            // console.log(item);
            if (!onlyShow) {
                this.$nextTick(() => {
                    document
                        .querySelector(`#menu-${item.id}`)
                        .scrollIntoView(true);
                });
            }
            this.treeData.map((dataItem) => {
                if (dataItem.id === item.id) {
                    dataItem.isActive = true;
                } else {
                    dataItem.isActive = false;
                }
            });
            this.$forceUpdate();
        },
    },
};
</script>
<style lang="scss" scoped>
.auth-table {
    &-title-container {
        background-color: #f2f2f2;
        display: flex;
        padding: 10px 0;
    }
    &-title {
        font-weight: bold;
        width: 140px;
        padding-left: 15px;
    }
    &-module-title {
        font-weight: bold;
        font-size: 16px;
        color: #ccc;
        padding: 5px 0;
    }
    &-checkbox {
        margin-left: 15px;
        font-size: 12px;
    }
    
    &-menu-container {
        padding-bottom: 15px;
        margin-bottom: 15px;
        border-bottom: 1px solid #eee;
    }
    &-content {
        height: 400px;
        display: flex;
        &-menu {
            overflow: auto;
            .auth-table-title {
                padding: 10px 0 10px 15px;
                background-color: #f2f2f2;
                cursor: pointer;
            }
            .menu-active {
                background-color: #fff;
            }
        }
        &-container {
            flex: 1;
            overflow: auto;
            padding-left: 15px;
            .auth-table-title {
                width: auto;
                padding: 0;
            }
            .auth-table-content-title {
                display: flex;
                padding: 15px 0;
            }
            .second-table {
                display: flex;
                padding-left: 15px;

                $commonBorder: 1px solid #ddd;

                border-top: $commonBorder;
                border-left: $commonBorder;
                border-right: $commonBorder;

                .second-table-title {
                    min-width: 210px;
                    border-right: $commonBorder;
                }

                &:last-child {
                    border-bottom: $commonBorder;
                }

                .auth-second-table-checkbox {
                    font-size: 12px;
                    padding: 10px 0;
                    padding-right: 15px;
                }
                .second-table-content {
                    display: flex;
                    flex-wrap: wrap;
                    padding-left: 15px;
                }
            }
        }
    }
}
</style>